import type { AutoFrameI, FlexFrameI, FrameI } from "tweenly"
import Border from "./ExpandableSections/Border"
import Fill from "./ExpandableSections/Fill"
import Filters from "./ExpandableSections/Filters"
import FlexLayout from "./ExpandableSections/FlexLayout"
import Appearance from "./ExpandableSections/Appearance"
import SizeAndPosition from "./ExpandableSections/SizeAndPosition"
import Transforms from "./ExpandableSections/Transforms"

interface Props {
    object: FrameI | FlexFrameI | AutoFrameI
    handleSetStyleValue: (property: any, value: any) => void
    handleSetObjectValue: (property: any, value: any) => void
    handleSetAttributeValue: (property: any, value: any) => void
}

const FrameTools = ({
    object,
    handleSetStyleValue,
    handleSetObjectValue,
    handleSetAttributeValue,
}: Props) => {
    return (
        <div>
            <SizeAndPosition object={object} handleSetValue={handleSetStyleValue} />
            <Appearance object={object} handleSetValue={handleSetStyleValue} />

            <FlexLayout object={object} handleSetObjectValue={handleSetObjectValue} />

            <Fill
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
                handleSetAttributeValue={handleSetAttributeValue}
            />

            <Border object={object} handleSetValue={handleSetStyleValue} />

            <Filters object={object} handleSetObjectValue={handleSetObjectValue} />

            <Transforms
                object={object}
                handleSetStyleValue={handleSetStyleValue}
                handleSetObjectValue={handleSetObjectValue}
            />
        </div>
    )
}

export default FrameTools
